// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pageContainer {
  position: absolute;
  top: 10%;
  left: 7%;
  z-index: 400;
}
.custom-pagination7 {
  display: flex;
  gap: 10px;
}

.custom-pagination7 .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  border: 1px solid white; /* 흰색 테두리 */
  background-color: transparent; /* 내부 투명 */
  border-radius: 50%;
  opacity: 1;
  transition: background-color 0.3s, opacity 0.3s;
}

.custom-pagination7 .swiper-pagination-bullet-active {
  background-color: white; /* 선택된 bullet은 흰색 */
  border-color: white; /* 테두리 유지 */
  opacity: 1;
}

@media (max-width: 767px) {
  .custom-pagination7 {
    gap: 2px;
  }

  .custom-pagination7 .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
  }

}`, "",{"version":3,"sources":["webpack://./src/Sections/section7.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,YAAY;AACd;AACA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB,EAAE,WAAW;EACpC,6BAA6B,EAAE,UAAU;EACzC,kBAAkB;EAClB,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,uBAAuB,EAAE,mBAAmB;EAC5C,mBAAmB,EAAE,WAAW;EAChC,UAAU;AACZ;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;AAEF","sourcesContent":[".pageContainer {\n  position: absolute;\n  top: 10%;\n  left: 7%;\n  z-index: 400;\n}\n.custom-pagination7 {\n  display: flex;\n  gap: 10px;\n}\n\n.custom-pagination7 .swiper-pagination-bullet {\n  width: 12px;\n  height: 12px;\n  border: 1px solid white; /* 흰색 테두리 */\n  background-color: transparent; /* 내부 투명 */\n  border-radius: 50%;\n  opacity: 1;\n  transition: background-color 0.3s, opacity 0.3s;\n}\n\n.custom-pagination7 .swiper-pagination-bullet-active {\n  background-color: white; /* 선택된 bullet은 흰색 */\n  border-color: white; /* 테두리 유지 */\n  opacity: 1;\n}\n\n@media (max-width: 767px) {\n  .custom-pagination7 {\n    gap: 2px;\n  }\n\n  .custom-pagination7 .swiper-pagination-bullet {\n    width: 8px;\n    height: 8px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
